import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { Checkbox, Button, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { toggleDocumentSelection, viewDocument } from '../../../ducks/DocumentsDucks';
import validMimeTypes from '../../../utility/validMimeTypes';

const DocumentsListItem = ({ document }) => {
  const dispatch = useDispatch();
  
  const callToggleDocumentSelection = useCallback(
    documentId => dispatch(toggleDocumentSelection(documentId)),
    [dispatch, document]
  );

  const callViewDocument = useCallback(
    documentId => dispatch(viewDocument(documentId)),
    [dispatch, document]
  );

  const documentWithSignatureAndMimeTypeInvalid = document.hasSignature && !validMimeTypes(document.mimeType)
  const documentWithSignatureAndFullySigned = document.hasSignature && document.documentInviteStatus === 'DONE';

  return (
    <DocumentArea>
      <DocumentThumb thumb={document.documentThumbSmallAssigned}>
        <Button
          onClick={() => callViewDocument(document.idDocument)}
          size="small">
          Visualizar
        </Button>
      </DocumentThumb>
      {
        documentWithSignatureAndMimeTypeInvalid 
          ? (
            <Tooltip title="Este tipo de arquivo não pode ser assinado digitalmente" >
              <DocumentSelectionCheckbox
                disabled={!validMimeTypes(document.mimeType)}
                checked={document.selected}
                onChange={() => callToggleDocumentSelection(document.idDocument)}
                >
                {document.documentTypeDescription}
              </DocumentSelectionCheckbox>
            </Tooltip>
          ) 
          : documentWithSignatureAndFullySigned 
            ? (
              <Tooltip title="Este documento já foi totalmente assinado digitalmente" >
                <DocumentSelectionCheckbox
                  disabled={documentWithSignatureAndFullySigned}
                  checked={document.selected}
                  onChange={() => callToggleDocumentSelection(document.idDocument)}
                  >
                  {document.documentTypeDescription}
                </DocumentSelectionCheckbox>
              </Tooltip>
              )
            : (
              <DocumentSelectionCheckbox
                checked={document.selected}
                onChange={() => callToggleDocumentSelection(document.idDocument)}
                >
                {document.documentTypeDescription}
              </DocumentSelectionCheckbox>
            )
      }
    </DocumentArea>
  )
}

const DocumentArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const DocumentThumb = styled.div`
  background-position: center;
  background-size: cover;
  border-radius: 10px;
  box-shadow: 3px 3px 20px rgba(0,0,0,.1);
  margin: 20px 10px;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 10px;

  ${({ thumb }) => css`
    background-image: url(${thumb});
  `}

  &:not(:hover) Button {
    opacity: 0;
    pointer-events: none;
  }
`;

const DocumentSelectionCheckbox = styled(Checkbox)`
  width: 155px;
  padding: 0 10px;
  text-align: center;
`;

export default DocumentsListItem;



// WEBPACK FOOTER //
// ./src/components/DocumentsList/DocumentsListItem/index.js